import { Clickable, Col, ContentTile, FeaturePanel, Row, Section, Wrapper } from '@ahmdigital/ui';

import { HOW_TO_PROTECT_YOURSELF, HOW_WE_PROTECT_YOU_TILE, SCAMS_TILE } from './fixtures';
import Head from '../../src/utils/head';
import magnifyImage from './images/magnify.svg';
import PageStrip from '../../src/client/components/page-strip';
import PrivacySecurityHero from './components/hero';
import RelatedTopicsTiles from './components/related-topics';
import TopTips from './components/top-tips';

const tiles = [
  {
    cta: {
      isClickable: true,
      title: 'Get in touch with us',
      to: 'https://ahm.com.au/contact-us',
    },
    summary: 'Need to chat? We’re here to help.',
    title: 'General Enquiries',
  },
  {
    cta: {
      isClickable: true,
      title: 'Report a scam',
      to: 'https://portal.scamwatch.gov.au/report-a-scam/',
    },
    summary: 'If you get any suspicious emails or texts, report them to Scamwatch.',
    title: 'Report a scam',
  },
  {
    cta: {
      isClickable: true,
      title: 'Visit Beyond Blue',
      to: 'https://www.beyondblue.org.au/',
    },
    summary: 'Information and support for anxiety, depression and suicide prevention.',
    title: 'Get mental health support',
  },
];

const PrivacySecurityHubPage = () => (
  <>
    <Head>
      <meta name="description" content="Learn more about how ahm is protecting your personal and health data" />
    </Head>
    <Wrapper size="extraExtraLarge">
      <PrivacySecurityHero />
      <Row isBoxed>
        <Col df sm={12}>
          <ContentTile variant="vertical" {...HOW_TO_PROTECT_YOURSELF} />
        </Col>
        <Col df sm={12}>
          <ContentTile variant="vertical" {...HOW_WE_PROTECT_YOU_TILE} />
        </Col>
      </Row>
      <Row isBoxed>
        <Col df>
          <ContentTile variant="fullWidth" {...SCAMS_TILE} />
        </Col>
      </Row>
      <TopTips />
      <Row isBoxed>
        <Col df>
          <RelatedTopicsTiles />
          <PageStrip
            text={
              <>
                Got questions? We’ve got answers.{' '}
                <Clickable to="https://help.ahm.com.au/hc/en-us/articles/9483812407311">
                  Check out our FAQ page.
                </Clickable>
              </>
            }
            image={magnifyImage.src}
            variant={['illustration', 'noHorizontalMargin']}
          />

          <Row>
            <Col df={10} dfOffset={1} sm={12} smOffset={0}>
              <Section variant={['marginTopSpacer4', 'marginBottomSpacer4']}>
                <FeaturePanel title="More help and support" tiles={tiles} />
              </Section>
            </Col>
          </Row>
        </Col>
      </Row>
    </Wrapper>
  </>
);

export default PrivacySecurityHubPage;
